export default "__VITE_ASSET__BnuFFUWR__"